export default {
    rows: {
        'lease-notes': {
            valueCells: [{
                editable: true,
                value: ''
            }]
        }
    }
};